// TODO(visgl-burn-in): remove this deep `@react-google-maps/api/dist/...` import and
// `GOOGLE_MAPS_LIBRARIES` (only the legacy `useLoadScript` loader consumes it) once
// CONSUMER_ENABLE_GOOGLE_MAPS_API_UPDATE is fully rolled out.
import { Libraries } from '@react-google-maps/api/dist/utils/make-load-script-url';

export const GOOGLE_MAPS_LIBRARIES: Libraries = ['places'];
